import ConjItem from './ConjItem';

export default ConjItem;



// WEBPACK FOOTER //
// ./src/components/ConjTable/ConjBlock/ConjItem/index.js